(ns com.theplantscape.plant-web.components.search
  (:require
   [clojure.set :refer [rename-keys]]
   [com.theplantscape.local-store.ensemble
    :as db
    :refer [add-new-plant fetch-plant-eid-from-uuid namespace-map]]
   [cljs.core.async :refer [<! go]]
   [com.theplantscape.plant-web.api.plants :refer [fetch-plant-async fetch-plant-fallback]]
   [com.theplantscape.plant-web.draw.events :as evt]
   [com.theplantscape.plant-web.draw.state
    :refer [app-state hide-modal set-mode]]
   [com.theplantscape.plant-web.store.core :refer [fetch-search-results]]
   [com.theplantscape.web-ui.ensemble :refer [icon-close]]
   [com.theplantscape.web-ui.tailwind.ensemble :refer [ui-btn-link]]
   [reagent.core :as r]
   [reitit.frontend.easy :as rfe]))

(defn lookup-plant->add-to-db
  [{:keys [id type] :as plant} ]
  (go
    (let [[_ response] (<! (fetch-plant-async id))]
      (prn (str "lookup " id))
         (prn (-> response :plant (rename-keys {:xt/id :plant/id})))
         (set-mode :insert type)
         (add-new-plant (-> response :plant (rename-keys {:xt/id :plant/id})))
         (prn "----------")
         (prn id)
         (prn (fetch-plant-eid-from-uuid (str id)))
         (prn (fetch-plant-eid-from-uuid (str id)))
         (swap! app-state assoc-in [:current :plant] (fetch-plant-eid-from-uuid (str id)))
         (prn "########")
         (prn (-> @app-state :current :plant))
      #_(fetch-plant-async
       id
       (fn [response]
         (prn "response")
         (prn response)
         (prn plant)
         (prn (:plant response))
         (add-new-plant (:plant response)))
       (fn [] (add-new-plant (namespace-map :plant plant)))))))

(defn search-selected-plant [{:keys [id scientific-name common-name type] :as plant}]
  (prn (str "search modal " id))
  (hide-modal)
  (lookup-plant->add-to-db plant)
  ;; (add-new-plant (namespace-map :plant plant))
  ;; (set-mode :insert type)
  ;; (prn "after")
  ;; (prn (fetch-plant-eid-from-uuid id))
  ;; (swap! app-state assoc-in [:current :plant] (fetch-plant-eid-from-uuid id))
  ;; (prn (-> @app-state :current :plant))
  )

(defn search-on-click [{:keys [id scientific-name common-name type] :as plant}]
  (prn (str "search on click " id))
  (prn (namespace-map :plant plant))
  (hide-modal)
  (let [plant-full (lookup-plant->add-to-db plant)]
    (print "plant full")
    (print plant-full)
    )
  ;(add-new-plant (namespace-map :plant plant))
  ;;(set-mode :insert type)
  (prn "after")
  (prn (fetch-plant-eid-from-uuid id))
  ;;(swap! app-state assoc-in [:current :plant] (fetch-plant-eid-from-uuid id))
  (prn (-> @app-state :current :plant)))

(defn search-modal [{:keys [id scientific-name common-name type] :as plant}]
  (prn (str "search modal " id))
  (prn (namespace-map :plant plant))
  (hide-modal)
  (lookup-plant->add-to-db plant)
  ;; (add-new-plant (namespace-map :plant plant))
  ;; (set-mode :insert type)
  ;; (prn "after")
  ;; (prn (fetch-plant-eid-from-uuid id))
  ;; (swap! app-state assoc-in [:current :plant] (fetch-plant-eid-from-uuid id))
  ;; (prn (-> @app-state :current :plant))
  )

(defn ui-plant-list-no-results []
  [:div [:div.h-10.m-2
         [:span.black-60.w-50.f6 "No matches plant not found. "]]
   [:div.h-10-m-2 [ui-btn-link {:href (rfe/href :plant-add) :text "Add new plant"}]]])

(defn ui-plant-list-item
  [actionfn search-results idx {:keys [id scientific-name common-name taxonomy :plant/type] :as plant}]
  [:li.hover:bg-sky-500.box-border.pt-4.pb-4.pl-4.rounded-lg
   {:key idx :class "insert-slide-down "}
   [:div.w-full.flex.flex-row
    #_(if (= "plant" taxonomy)
      [:span "P - "]
      [:span "F - "])
    [:div.grow
     (when actionfn
       {:on-click (fn on-click-plant []
                    (reset! search-results [])
                    (prn "Clicked on plant")
                    (actionfn plant))})
     [:div.text-base
      {:title "Scientific / Botanical name"}
      (-> plant :scientific-name)]
     [:p.text-xs
      {:title "Common name"}
      [:span.black-60.w-50.f6 common-name]]]
    [:div
     (when (some? (-> plant :season))
       [:span.tr.black-60.w-50.f6
        (str "season "
             (-> plant :season :start) " "
             (-> plant :season :end))])]]])

(defn ui-plant-list [actionfn type search-results]
  [:div
   (when (seq (:plants @search-results)) 
     (into  [:ul#search-results.list-none.mt-4.mb-4.rounded-lg.bg-blue-600.border-sky-500.p-4
             [:li.text-sm.font-bold "Plants"]]
            (map-indexed
             (partial ui-plant-list-item actionfn search-results)
             (:plants @search-results))))
   (when (seq (:families @search-results)) 
     (into  [:ul#search-results.list-none.mt-4.mb-4.rounded-lg.bg-blue-600.border-sky-500.p-4
             [:li.text-sm.font-bold "Plant family"]]
            (map-indexed
             (partial ui-plant-list-item actionfn search-results)
             (:families @search-results))))
   (when (and (empty? (:plants @search-results)) (empty? (:families @search-results)))
     [ui-plant-list-no-results])])

(defn ui-zone-filter
  ([filter-layer-fn] (ui-zone-filter nil filter-layer-fn))
  ([type filter-layer-fn]
   [:ul#search-filters.flex.flex-wrap.text-sm.mt-4.mb-4
    [:li.mr-2 {:class (when-not (= nil type) "opacity-50") :on-click #(filter-layer-fn nil)} [:i.fas.fa-tree "All"]]
    [:li.dim.mr-2 {:class (when-not (= :canopy type) "opacity-50")
                   :on-click #(filter-layer-fn :canopy)} [:i.fas.fa-tree "Canopy tree"]]
    [:li.dib.mr-2 {:class (when-not (= :sub-canopy type) "opacity-50")
                   :on-click #(filter-layer-fn :sub-canopy)} [:i.fas.fa-leaf "Sub canopy tree"]]
    [:li.dib.mr-2 {:class (when-not (= :shrub type) "opacity-50")
                   :on-click #(filter-layer-fn :shrub)} [:i.fas.fa-spa "Bush"]]
    [:li.dib.mr-2 {:class (when-not (= :herbaceous type) "opacity-50")
                   :on-click #(filter-layer-fn :herbaceous)} [:i.fas.fa-spa "Plants"]]
    [:li.dib.mr-2 {:class (when-not (= :ground type) "opacity-50")
                   :on-click #(filter-layer-fn :ground)} [:i.fas.fa-seedling "Ground"]]
    [:li.dib.mr-2 {:class (when-not (= :root type) "opacity-50")
                   :on-click #(filter-layer-fn :root)} [:i.fas.fa-carrot "Root"]]
    [:li.dib.mr-2 {:class (when-not (= :vine type) "opacity-50")
                   :on-click #(filter-layer-fn :vine)} [:i.fas.fa-running "Vine"]]]))

(defn ui-plant-search-btn [action-fn]
  (let [search (r/atom [])
        type (r/atom nil)
        filter-fn (partial reset! type)]
    (r/create-class
     {:component-did-mount
      #(.focus (.getElementById js/document "search"))
      :reagent-render
      (fn [action-fn]
        [:div#search-bar.ml-4.mr-4.flex.justify-center
         [:div.w-full
          [ui-zone-filter @type filter-fn]
          [:input#search.w-full.p-2
           {:on-change
            (fn [evt] (fetch-search-results
                       {:search (-> evt .-target .-value)}
                       (fn [results] (reset! search results))))
            :on-key-up #(evt/key-enter % (fn [] (fetch-search-results
                                                 {:search (-> % .-target .-value)}
                                                 (fn [results] (reset! search results)))
                                           #_(reset! search (-> % .-target .-value))))}]
                                        ;[:span (:tool @app-state)]
          [ui-plant-list action-fn type @search]]])})))

(defn update-search-results [search-store results]
  (reset! search-store {:families (mapv #(update %1 :type (fn [plant-type]
                                                            (keyword (or plant-type "family")))) (:families results))
                        :plants (mapv #(update %1 :type keyword) (:plants results))})
  )

(defn ui-plant-search [action-fn]
  (let [search-input (r/atom nil)
        search (r/atom {})
        ;type (r/atom nil)
        filters (r/atom {:search "" :layer nil})
        filter-fn (partial swap! filters  assoc :layer)]
    (r/create-class
     {:component-did-mount
      (fn [this] (.focus @search-input))
      :reagent-render
      (fn [action-fn]
        [:div#search-bar.ml-4.mr-4.mb-4.flex.justify-center ;.overflow-hidden
         [:div.w-full
          [:div.flex
           [:div.grow
            [ui-zone-filter (-> @filters :layer) filter-fn]]
           [:div.flex-none.w-8.h-8.mt-2
            (when (seq @search)
              [:div.w-8.h-8
               {:on-click (fn clear-results []
                            (reset! search {}))}
               icon-close])]]

          [:input#search.w-full.p-4
           {:ref #(reset! search-input %)
            :placeholder "Search for plant"
            :on-change
            (fn [evt]
              (.-preventDefault evt)
              (.-stopPropagation evt)
              (if (= 0 (-> evt .-target .-value .-length))
                (reset! search {})
                (do (swap! filters assoc :search  (-> evt .-target .-value))
                    (fetch-search-results
                     @filters
                     (partial update-search-results search)
                     #_(fn [results] (reset! search results))))))
            :on-key-up #(evt/key-enter % (fn []
                                           (fetch-search-results @filters (fn [results] (reset! search results)))))}]
          (when (some? (:search @filters))
            [ui-plant-list action-fn type search])]])})))


